import {
  Component,
  Input,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
  AfterViewInit,
  Signal,
  viewChild,
  HostListener,
} from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

interface RightSidePanelService {
  isOpen$: Observable<boolean>;
  emitResult: (result: any | false) => void;
}

import { FuseConfigService } from '../../../../@fuse/services/config.service';
import { FuseSidebarService } from '../../../../@fuse/components/sidebar/sidebar.service';
import { navigation } from '../../../navigation/navigation';
import { NGXLogger } from 'ngx-logger';
import {
  TopAlertModel,
  TopAlertsComponent,
} from '../../../gt2/components/top-alerts/top-alerts.component';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FuseDirectivesModule } from '../../../../@fuse/directives/directives';
import { FusePipesModule } from '../../../../@fuse/pipes/pipes.module';
import { MatInputModule } from '@angular/material/input';
import { FuseSidebarModule } from '../../../../@fuse/components';
import { ContentComponent } from '../../components/content/content.component';
import { NgProgressbar, NgProgressRef } from 'ngx-progressbar';
import { NgxPermissionsModule } from 'ngx-permissions';
import { NavbarComponent } from '../../components/navbar/navbar.component';
import { ChatModule } from '../../../main/apps/chat/chat.module';
import { ChatPanelComponent } from '../../components/chat-panel/chat-panel.component';
import { ChatSidePanelService } from '../../../gt2/services/chat-side-panel.service';
import { WorkInProgressService } from '../../../gt2/services/work-in-progress.service';
import { ToolbarComponent } from '../../components/toolbar/toolbar.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { NgProgressHttp } from 'ngx-progressbar/http';
import { CreateClientEnterpriseWithDetailsComponent } from '../../../gt2/components/dialogs/create-client-enterprise-with-details/create-client-enterprise-with-details.component';
import { CreateClientEnterprisePanelService } from '../../../gt2/services/create-client-enterprise-panel.service';
import { CreateEnterpriseWithDetailsComponent } from '../../../gt2/components/dialogs/create-enterprise-with-details/create-enterprise-with-details.component';
import { CreateEnterprisePanelService } from '../../../gt2/services/create-enterprise-panel.service';
import { CreateClientWithDetailsComponent } from '../../../gt2/components/dialogs/create-client-with-details/create-client-with-details.component';
import { CreateClientPanelService } from '../../../gt2/services/create-client-panel.service';
import { SelectClientComponent } from '../../../gt2/components/dialogs/select-client/select-client.component';
import { SelectClientPanelService } from '../../../gt2/services/select-client-panel.service';
import { QuickOrderComponent } from '../../../gt2/components/dialogs/quick-order/quick-order.component';
import { QuickOrderPanelService } from '../../../gt2/services/quick-order-panel.service';
import { ConvertSubmissionPanelService } from '../../../gt2/services/convert-submission-panel.service';
import { ConvertSubmissionComponent } from '../../../gt2/components/dialogs/convert-submission/convert-submission.component';
import { CreateDeliveryRequestComponent } from '../../../gt2/components/dialogs/create-delivery-request/create-delivery-request.component';
import { CreateDeliveryRequestPanelService } from '../../../gt2/services/create-delivery-request-panel.service';
import { CreateFlowComponent } from '../../../gt2/components/dialogs/create-flow/create-flow.component';
import { CreateFlowPanelService } from '../../../gt2/services/create-flow-panel.service';
import { CreateProgramComponent } from '../../../gt2/components/dialogs/create-program/create-program.component';
import { CreateProgramPanelService } from '../../../gt2/services/create-program-panel.service';
import { SelectInternalRoomComponent } from '../../../gt2/components/dialogs/create-program/select-internal-room/select-internal-room.component';
import { SelectInternalRoomPanelService } from '../../../gt2/services/select-internal-room-panel.service';
import { CreateGuestComponent } from '../../../gt2/components/dialogs/create-guest/create-guest.component';
import { CreateGuestPanelService } from '../../../gt2/services/create-guest-panel.service';
import { CreateDepositRequestComponent } from '../../../gt2/components/dialogs/create-deposit-request/create-deposit-request.component';
import { CreateDepositRequestPanelService } from '../../../gt2/services/create-deposit-request-panel.service';
import { CreateDepositInComponent } from '../../../gt2/components/dialogs/create-deposit-in/create-deposit-in.component';
import { CreateDepositInPanelService } from '../../../gt2/services/create-deposit-in-panel.service';
import { CreateGroupDepositRequestComponent } from '../../../gt2/components/dialogs/create-group-deposit-request/create-group-deposit-request.component';
import { CreateGroupDepositRequestPanelService } from '../../../gt2/services/create-group-deposit-request-panel.service';
import { CreateGroupCashingComponent } from '../../../gt2/components/dialogs/create-group-cashing/create-group-cashing.component';
import { CreateGroupCashingPanelService } from '../../../gt2/services/create-group-cashing-panel.service';
import { EnterpriseCashingModalComponent } from '../../../gt2/content/enterprise-invoice/enterprise-cashing-modal/enterprise-cashing-modal.component';
import { EnterpriseCashingPanelService } from '../../../gt2/services/enterprise-cashing-panel.service';
import { ClientAttachEnterpriseTablePaginatedComponent } from '../../../gt2/components/dialogs/client-attach-enterprise-table-paginated/client-attach-enterprise-table-paginated.component';
import { ClientAttachEnterprisePanelService } from '../../../gt2/services/client-attach-enterprise-panel.service';
import { CreateLabourChargeComponent } from '../../../gt2/components/dialogs/create-labour-charge/create-labour-charge.component';
import { AddLabourChargePanelService } from '../../../gt2/services/add-labour-charge-panel.service';
import { EditLabourChargePanelService } from '../../../gt2/services/edit-labour-charge-panel.service';
import { AddServiceChargeComponent } from '../../../gt2/components/dialogs/add-service-charge/add-service-charge.component';
import { AddServiceChargePanelService } from '../../../gt2/services/add-service-charge-panel.service';
import { EditServiceChargePanelService } from '../../../gt2/services/edit-service-charge-panel.service';
import { AddSpecificConditionComponent } from '../../../gt2/components/dialogs/add-specific-condition/add-specific-condition.component';
import { AddSpecificConditionPanelService } from '../../../gt2/services/add-specific-condition-panel.service';
import { OrderProductDndComponent } from '../../../gt2/components/order-product-dnd/order-product-dnd.component';
import { AddProductPanelService } from '../../../gt2/services/add-product-panel.service';
import { UpsalePanelService } from '../../../gt2/services/upsale-panel.service';
import { OrderUpsalePanelComponent } from '../../../gt2/components/order-upsale-panel/order-upsale-panel.component';
import { UpsaleQuestionsPanelService } from '../../../gt2/services/upsale-questions-panel.service';
import { UpsaleQuestionsPanelComponent } from '../../../gt2/components/upsale-questions-panel/upsale-questions-panel.component';
import { ProductUpsellPanelService } from '../../../gt2/services/product-upsell-panel.service';
import { ProductUpsellPanelComponent } from '../../../gt2/components/product-upsell-panel/product-upsell-panel.component';
import { PhotoLibraryPanelService } from '../../../gt2/services/photo-library-panel.service';
import { PhotoLibraryPanelComponent } from '../../../gt2/components/photo-library-panel/photo-library-panel.component';
import { EditProductComponent } from '../../../gt2/content/orders/edit-product/edit-product.component';
import { EditProductPanelService } from '../../../gt2/services/edit-product-panel.service';
import { OrderMaterialDndComponent } from '../../../gt2/components/order-material-dnd/order-material-dnd.component';
import { AddMaterialPanelService } from '../../../gt2/services/add-material-panel.service';
import { EditMaterialComponent } from '../../../gt2/content/orders/edit-material/edit-material.component';
import { EditMaterialPanelService } from '../../../gt2/services/edit-material-panel.service';
import { EditMaterialComboPanelComponent } from '../../../gt2/components/edit-material-combo-panel/edit-material-combo-panel.component';
import { EditMaterialComboPanelService } from '../../../gt2/services/edit-material-combo-panel.service';
import { EditComboPanelComponent } from '../../../gt2/components/edit-combo-panel/edit-combo-panel.component';
import { EditComboPanelService } from '../../../gt2/services/edit-combo-panel.service';
import { AutomationDialogComponent } from '../../../gt2/content/settings/automations/automation-dialog/automation-dialog.component';
import { AutomationPanelService } from '../../../gt2/services/automation-panel.service';
import { SentEmailDetailComponent } from '../../../gt2/components/sent-emails/sent-email-detail/sent-email-detail.component';
import { SentEmailPanelService } from '../../../gt2/services/sent-email-panel.service';
import { UpgradePanelComponent } from '../../../gt2/components/upgrade-panel/upgrade-panel.component';
import { UpgradePanelService } from '../../../gt2/services/upgrade-panel.service';
import { BellPanelComponent } from '../../../gt2/components/notification-center/bell-panel/bell-panel.component';
import { BellPanelService } from '../../../gt2/services/bell-panel.service';

@Component({
  selector: 'vertical-layout-1',
  templateUrl: './layout-1.component.html',
  styleUrls: ['./layout-1.component.scss'],
  standalone: true,
  imports: [
    RouterModule,
    MatButtonModule,
    TranslateModule,
    CommonModule,
    FormsModule,
    ToolbarComponent,
    ReactiveFormsModule,
    NgProgressHttp,
    FuseDirectivesModule,
    FooterComponent,
    FusePipesModule,
    MatInputModule,
    TopAlertsComponent,
    FuseSidebarModule,
    ContentComponent,
    NgProgressbar,
    NgxPermissionsModule,
    NavbarComponent,
    CreateClientEnterpriseWithDetailsComponent,
    CreateEnterpriseWithDetailsComponent,
    CreateClientWithDetailsComponent,
    SelectClientComponent,
    QuickOrderComponent,
    ConvertSubmissionComponent,
    CreateDeliveryRequestComponent,
    CreateFlowComponent,
    CreateProgramComponent,
    SelectInternalRoomComponent,
    CreateGuestComponent,
    CreateDepositRequestComponent,
    CreateDepositInComponent,
    CreateGroupDepositRequestComponent,
    CreateGroupCashingComponent,
    EnterpriseCashingModalComponent,
    ClientAttachEnterpriseTablePaginatedComponent,
    CreateLabourChargeComponent,
    AddServiceChargeComponent,
    AddSpecificConditionComponent,
    OrderProductDndComponent,
    OrderUpsalePanelComponent,
    UpsaleQuestionsPanelComponent,
    ProductUpsellPanelComponent,
    PhotoLibraryPanelComponent,
    EditProductComponent,
    OrderMaterialDndComponent,
    EditMaterialComboPanelComponent,
    EditComboPanelComponent,
    EditMaterialComponent,
    AutomationDialogComponent,
    SentEmailDetailComponent,
    BellPanelComponent,
    UpgradePanelComponent,
    ChatModule,
    ChatPanelComponent,
  ],
  encapsulation: ViewEncapsulation.None,
})
export class VerticalLayout1Component
  implements OnInit, OnDestroy, AfterViewInit
{
  progressBar: Signal<NgProgressRef> | any = viewChild(NgProgressRef);

  start() {
    this.progressBar().start();
  }
  fuseConfig: any;
  navigation: any;
  // messages: Message[] = ["les pata"];
  // message: string = "C'est bon des patates! Oui, c'est bon dedans le bedon. C'est comme...";
  // @Input() message: string;
  // @Input() messageColor: string;
  // @Input() messageClosable: boolean;
  @Input() topAlerts: TopAlertModel[] = [];
  isScreenWide: boolean = window.innerWidth > 1700;

  // Private
  private _unsubscribeAll: Subject<any>;
  // LIFO stack of currently-open right-side panels for ESC handling
  private _openPanels = new Set<RightSidePanelService>();

  /**
   * Constructor
   *
   * @param {FuseConfigService} _fuseConfigService
   */
  constructor(
    private _fuseConfigService: FuseConfigService,
    private _fuseSidebarService: FuseSidebarService,
    public logger: NGXLogger,
    public createClientEnterprisePanelService: CreateClientEnterprisePanelService,
    public createEnterprisePanelService: CreateEnterprisePanelService,
    public createClientPanelService: CreateClientPanelService,
    public selectClientPanelService: SelectClientPanelService,
    public quickOrderPanelService: QuickOrderPanelService,
    public convertSubmissionPanelService: ConvertSubmissionPanelService,
    public createDeliveryRequestPanelService: CreateDeliveryRequestPanelService,
    public createFlowPanelService: CreateFlowPanelService,
    public createProgramPanelService: CreateProgramPanelService,
    public selectInternalRoomPanelService: SelectInternalRoomPanelService,
    public createGuestPanelService: CreateGuestPanelService,
    public createDepositRequestPanelService: CreateDepositRequestPanelService,
    public createDepositInPanelService: CreateDepositInPanelService,
    public createGroupDepositRequestPanelService: CreateGroupDepositRequestPanelService,
    public createGroupCashingPanelService: CreateGroupCashingPanelService,
    public enterpriseCashingPanelService: EnterpriseCashingPanelService,
    public clientAttachEnterprisePanelService: ClientAttachEnterprisePanelService,
    public addLabourChargePanelService: AddLabourChargePanelService,
    public editLabourChargePanelService: EditLabourChargePanelService,
    public addServiceChargePanelService: AddServiceChargePanelService,
    public editServiceChargePanelService: EditServiceChargePanelService,
    public addSpecificConditionPanelService: AddSpecificConditionPanelService,
    public addProductPanelService: AddProductPanelService,
    public upsalePanelService: UpsalePanelService,
    public upsaleQuestionsPanelService: UpsaleQuestionsPanelService,
    public productUpsellPanelService: ProductUpsellPanelService,
    public photoLibraryPanelService: PhotoLibraryPanelService,
    public editProductPanelService: EditProductPanelService,
    public addMaterialPanelService: AddMaterialPanelService,
    public editMaterialPanelService: EditMaterialPanelService,
    public editMaterialComboPanelService: EditMaterialComboPanelService,
    public editComboPanelService: EditComboPanelService,
    public automationPanelService: AutomationPanelService,
    public sentEmailPanelService: SentEmailPanelService,
    public upgradePanelService: UpgradePanelService,
    public bellPanelService: BellPanelService,
    public chatSidePanelService: ChatSidePanelService,
    private workInProgressService: WorkInProgressService,
  ) {
    // Set the defaults
    this.navigation = navigation;

    // Set the private defaults
    this._unsubscribeAll = new Subject();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    this.isScreenWide = window.innerWidth > 1700;
  }

  @HostListener('document:keydown.escape', ['$event'])
  onEscape(event: KeyboardEvent): void {
    // Defer to overlays (mat-select, datepicker, dialogs, etc.) that already handled ESC.
    if (event.defaultPrevented || this._openPanels.size === 0) {
      return;
    }
    const lastOpen = Array.from(this._openPanels).pop();
    if (lastOpen) {
      event.preventDefault();
      event.stopPropagation();
      lastOpen.emitResult(false);
    }
  }

  // Sidebar names must match the fuse-sidebar name="..." attributes in the template
  private get _panelEntries(): {
    name: string;
    service: RightSidePanelService;
  }[] {
    return [
      { name: 'selectClientPanel', service: this.selectClientPanelService },
      { name: 'quickOrderPanel', service: this.quickOrderPanelService },
      {
        name: 'convertSubmissionPanel',
        service: this.convertSubmissionPanelService,
      },
      {
        name: 'createClientEnterprisePanel',
        service: this.createClientEnterprisePanelService,
      },
      {
        name: 'createEnterprisePanel',
        service: this.createEnterprisePanelService,
      },
      { name: 'createClientPanel', service: this.createClientPanelService },
      {
        name: 'createDeliveryRequestPanel',
        service: this.createDeliveryRequestPanelService,
      },
      { name: 'createFlowPanel', service: this.createFlowPanelService },
      { name: 'createProgramPanel', service: this.createProgramPanelService },
      {
        name: 'selectInternalRoomPanel',
        service: this.selectInternalRoomPanelService,
      },
      { name: 'createGuestPanel', service: this.createGuestPanelService },
      {
        name: 'createDepositRequestPanel',
        service: this.createDepositRequestPanelService,
      },
      {
        name: 'createDepositInPanel',
        service: this.createDepositInPanelService,
      },
      {
        name: 'createGroupDepositRequestPanel',
        service: this.createGroupDepositRequestPanelService,
      },
      {
        name: 'createGroupCashingPanel',
        service: this.createGroupCashingPanelService,
      },
      {
        name: 'enterpriseCashingPanel',
        service: this.enterpriseCashingPanelService,
      },
      {
        name: 'clientAttachEnterprisePanel',
        service: this.clientAttachEnterprisePanelService,
      },
      {
        name: 'addLabourChargePanel',
        service: this.addLabourChargePanelService,
      },
      {
        name: 'editLabourChargePanel',
        service: this.editLabourChargePanelService,
      },
      {
        name: 'addServiceChargePanel',
        service: this.addServiceChargePanelService,
      },
      {
        name: 'editServiceChargePanel',
        service: this.editServiceChargePanelService,
      },
      {
        name: 'addSpecificConditionPanel',
        service: this.addSpecificConditionPanelService,
      },
      { name: 'addProductPanel', service: this.addProductPanelService },
      { name: 'upsalePanel', service: this.upsalePanelService },
      {
        name: 'upsaleQuestionsPanel',
        service: this.upsaleQuestionsPanelService,
      },
      { name: 'productUpsellPanel', service: this.productUpsellPanelService },
      { name: 'photoLibraryPanel', service: this.photoLibraryPanelService },
      { name: 'editProductPanel', service: this.editProductPanelService },
      { name: 'addMaterialPanel', service: this.addMaterialPanelService },
      { name: 'editMaterialPanel', service: this.editMaterialPanelService },
      {
        name: 'editMaterialComboPanel',
        service: this.editMaterialComboPanelService,
      },
      { name: 'editComboPanel', service: this.editComboPanelService },
      { name: 'automationPanel', service: this.automationPanelService },
      { name: 'sentEmailPanel', service: this.sentEmailPanelService },
      { name: 'upgradePanel', service: this.upgradePanelService },
      { name: 'bellPanel', service: this.bellPanelService },
    ];
  }

  private get _panelServices(): RightSidePanelService[] {
    return this._panelEntries.map((entry) => entry.service);
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    this.isScreenWide = window.innerWidth > 1700;
    // Subscribe to config changes

    this._fuseConfigService.config
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe({
        next: (config: any) => {
          this.fuseConfig = config;
        },
      });

    // Track open right-side panels so ESC can close the topmost one
    this._panelServices.forEach((svc) => {
      svc.isOpen$.pipe(takeUntil(this._unsubscribeAll)).subscribe({
        next: (open) => {
          this._openPanels.delete(svc);
          if (open) {
            this._openPanels.add(svc);
          }
          this.syncWorkInProgress();
        },
      });
    });
  }

  /**
   * Un panneau latéral ouvert = travail en cours (un reload le détruirait).
   * La cloche (notifications) ne tient rien d'éditable : exclue.
   */
  private syncWorkInProgress(): void {
    const editingPanelOpen = Array.from(this._openPanels).some(
      (svc) => svc !== this.bellPanelService,
    );
    this.workInProgressService.setRightPanelOpen(editingPanelOpen);
  }
  get foldedValue(): boolean {
    return !this.isScreenWide;
  }
  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(true);
    this._unsubscribeAll.complete();
  }

  ngAfterViewInit() {
    // Resync panel services when their sidebar closes without emitResult
    // (ex: clic sur le backdrop) — sinon le service reste "ouvert" avec les
    // données périmées et la prochaine ouverture montre l'ancien contenu.
    this._panelEntries.forEach(({ name, service }) => {
      this._fuseSidebarService
        .getSidebar(name)
        ?.openedChanged.pipe(takeUntil(this._unsubscribeAll))
        .subscribe({
          next: (opened: boolean) => {
            if (!opened) {
              // Différé : sur le chemin normal (emitResult), le sidebar se
              // ferme AVANT que le service passe à fermé — un appel synchrone
              // ici émettrait false avant le vrai résultat.
              setTimeout(() => {
                if (this._openPanels.has(service)) {
                  service.emitResult(false);
                }
              });
            }
          },
        });
    });
  }

  onProgressBarStarted() {
    // this.logger.info('FuseMainComponent.onStarted() ::::::::::::::::::::::');
  }

  onProgressBarCompleted() {
    // this.logger.info('FuseMainComponent.onCompleted() ::::::::::::::::::::::');
  }
}
